import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './topInfoBarPopup.css'
import { Logo } from '../../../../components/basic/layout'

export const TopInfoBarPopup = ({icon, price, payments, wording}) => (
    <div className="popup-container-grey">
        <div className="popup-container">
            <div>
                <FontAwesomeIcon icon={icon} /> &nbsp; ${price} or {payments.length} payments of ${payments[0]}
            </div>
            <h3>Payment Options</h3>
            <p>Jostens provides a range of different payment options to suit your needs. You may be eligible to choose a {payments.length} interest-free payment plan.</p>
            <span>Pricing below is estimated and does not include taxes or fees; these charges will be added at checkout, if applicable. Minimum
                <br /> purchase requirements and eligibility restrictions apply. <a href={window.location.origin + "/help/orders/payment-options"} target="_blank">Terms and Conditions</a>
            </span>
            <div className="popup-box">
                <div className="popup-payment-plan"><Logo src="/images/aprimo/J-Bug_200px.png" /> &nbsp;{payments.length}-payment plan schedule </div>
                {payments.map((payment, i)=>(<div>Payment # ${i+1} - ${payment} <span className="payment-days"> | {wording(i)}</span></div>))}
            </div>
        </div>
    </div>
)